import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Spin } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
`;

const StyledCard = styled(Card)`
  width: 400px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const { Title } = Typography;

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { loginUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/'; // Redirect back or to dashboard

  const onFinish = async (values) => {
    setLoading(true);
    setError('');
    try {
      await loginUser(values);
      navigate(from, { replace: true }); // Redirect after successful login
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginContainer>
      <StyledCard>
        <Title level={2} style={{ textAlign: 'center', marginBottom: '24px' }}>
          Admin Login
        </Title>
        <Form
          name="admin_login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
        >
          {error && <Alert message={error} type="error" showIcon closable style={{ marginBottom: '20px' }} onClose={() => setError('')} />}

          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Please input your Email!', type: 'email' }]}
          >
            <Input prefix={<MailOutlined />} placeholder="Email" size="large" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your Password!' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Password" size="large" />
          </Form.Item>

          {/* Add Remember me or Forgot password if needed */}

          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large" loading={loading}>
              {loading ? <Spin /> : 'Log in'}
            </Button>
          </Form.Item>
           {/* Optionally add link to signup if public signup is allowed */}
           {/* <Form.Item style={{ textAlign: 'center' }}>
                <Link to="/signup">Don't have an account? Sign Up</Link>
           </Form.Item> */}
        </Form>
      </StyledCard>
    </LoginContainer>
  );
};

export default LoginPage;